const PROMOTED_LINK_PLACEHOLDER = "PROMOTED_LINK";

const PROMOTED_LINK_WARNING =
  "This article still contains PROMOTED_LINK. Replace it using the link editor before publishing or sharing.";

/** How long the placeholder stays highlighted after being revealed. */
const PROMOTED_LINK_HIGHLIGHT_MS = 2000;

/** Outline drawn around the placeholder so the eye lands on it immediately. */
const PROMOTED_LINK_HIGHLIGHT_OUTLINE = "3px solid #ff9800";

const hasPromotedLinkPlaceholder = (content?: string | null): boolean =>
  content?.includes(PROMOTED_LINK_PLACEHOLDER) ?? false;

/**
 * Scrolls the first unreplaced promoted-link placeholder into view and
 * highlights it briefly.
 *
 * The warning that prompts this is raised from the publish and share flows,
 * which have no access to the editor instance. Going through the rendered
 * DOM keeps the lookup working from any of those call sites without
 * threading the editor through them.
 *
 * @returns Whether a placeholder was found to reveal.
 */
const revealPromotedLinkPlaceholder = (): boolean => {
  const link = document.querySelector<HTMLElement>(
    `a[href="${PROMOTED_LINK_PLACEHOLDER}"]`,
  );

  if (!link) {
    return false;
  }

  link.scrollIntoView({ behavior: "smooth", block: "center" });

  const previousOutline = link.style.outline;
  const previousOutlineOffset = link.style.outlineOffset;
  link.style.outline = PROMOTED_LINK_HIGHLIGHT_OUTLINE;
  link.style.outlineOffset = "2px";

  window.setTimeout(() => {
    link.style.outline = previousOutline;
    link.style.outlineOffset = previousOutlineOffset;
  }, PROMOTED_LINK_HIGHLIGHT_MS);

  return true;
};

export {
  hasPromotedLinkPlaceholder,
  revealPromotedLinkPlaceholder,
  PROMOTED_LINK_PLACEHOLDER,
  PROMOTED_LINK_WARNING,
};
